import { UseFormRegister } from 'react-hook-form';

import Button from '@/components/Button/Button';
import FileUpload from '@/components/FileUpload/FileUpload';
import InputText from '@/components/InputText/InputText';
import { UpdateChildFormData } from '@/pages/admin/children/[id]';
import { Child } from '@/types/child';

type Props = {
  child: Child | undefined;
  register: UseFormRegister<UpdateChildFormData>;
  rehabilitationCertificateFile: File | undefined;
  setRehabilitationCertificateFile: (v: File | undefined) => void;
  assessmentSheetFile: File | undefined;
  setAssessmentSheetFile: (v: File | undefined) => void;
  onDownloadReport: () => void;
};

export const OtherForm = ({
  child,
  register,
  setRehabilitationCertificateFile,
  setAssessmentSheetFile,
  onDownloadReport,
}: Props) => {
  return (
    <div className="flex flex-col justify-center">
      <div className="flex flex-row items-center">
        <div className="flex flex-col">
          <FileUpload
            label="療育手帳"
            buttonText="画像アップロード"
            accept="image/*"
            required={false}
            setFile={setRehabilitationCertificateFile}
            initialValue={child?.rehabilitation_certificate_image_url || ''}
          />
        </div>
      </div>
      <div className="flex flex-row items-center">
        <div className="flex flex-col">
          <FileUpload
            label="アセスメントシート"
            buttonText="画像アップロード"
            accept="image/*"
            required={false}
            setFile={setAssessmentSheetFile}
            initialValue={child?.assessment_sheet_image_url || ''}
          />
        </div>
      </div>
      <div className="flex flex-row gap-4">
        <InputText
          label="障がい内容"
          type="text"
          required={false}
          {...register('disabilityDetails')}
        />
        <InputText
          label="アレルギー等"
          type="text"
          required={false}
          {...register('allergies')}
        />
      </div>
      <div className="w-1/2">
        <InputText
          label="実習先"
          type="text"
          required={false}
          {...register('trainingLocation')}
        />
      </div>
      <div className="flex flex-row gap-4">
        <InputText
          label="備考"
          type="textarea"
          required={false}
          {...register('notes')}
        />
      </div>
      <div className="mt-6">
        <h3 className="text-lg font-bold">契約内容報告書</h3>
        <Button
          type="button"
          size="lg"
          variant="solid-fill"
          onClick={onDownloadReport}
        >
          帳票出力
        </Button>
      </div>
    </div>
  );
};
